/**
 * Sincroniza credenciales MIT (desde API `transpais.credentials` → atom `{ name, value }`)
 * con el proceso Electron para LOGIN nativo del pinpad (Windows).
 *
 * Contrato IPC: solo `{ user, password }`. La URL MIT la define TranspaisLink.exe internamente.
 */

/**
 * @param {{ name?: string, value?: string }} credentialsMit — API devuelve `name` (usuario) y `value` (contraseña).
 */
export async function syncElectronPinpadCredentials (credentialsMit) {
  if (typeof window === 'undefined' || !window.electronAPI?.setPinpadCredentials) {
    console.log('[ELECTRON AUTH] setPinpadCredentials no disponible (no es Electron o preload antiguo)')
    return { ok: false, skipped: true }
  }

  const user = credentialsMit?.name != null ? String(credentialsMit.name).trim() : ''
  const password = credentialsMit?.value != null ? String(credentialsMit.value) : ''

  if (!user || !password) {
    console.warn('[ELECTRON AUTH] credenciales MIT incompletas (name/value)')
    return { ok: false, error: 'incomplete_credentials' }
  }

  const payload = { user, password }

  console.log('[ELECTRON AUTH] sending credentials')
  try {
    const res = await window.electronAPI.setPinpadCredentials(payload)
    if (!res?.ok) {
      console.warn('[ELECTRON AUTH] login en Electron falló', res?.error)
      return { ok: false, error: res?.error || 'login_failed' }
    }
    return { ok: true }
  } catch (e) {
    console.warn('[ELECTRON AUTH] error IPC', e)
    return { ok: false, error: e instanceof Error ? e.message : String(e) }
  }
}

/**
 * Consulta estado y reintenta envío si no hay sesión MIT en el bridge nativo.
 * @param {{ name?: string, value?: string }} credentialsMit
 */
export async function ensureElectronPinpadReady (credentialsMit) {
  if (typeof window === 'undefined' || !window.electronAPI?.getPinpadStatus) {
    return { ok: false, skipped: true }
  }

  let status = await window.electronAPI.getPinpadStatus()
  console.log('[ELECTRON AUTH] status', status)

  if (status?.loggedIn) {
    return { ok: true, status }
  }

  console.log('[ELECTRON AUTH] retrying')
  const sync = await syncElectronPinpadCredentials(credentialsMit)
  status = await window.electronAPI.getPinpadStatus()
  console.log('[ELECTRON AUTH] status after sync', status)

  if (!sync.ok && !sync.skipped) {
    console.warn('[ELECTRON AUTH] no se pudo autenticar el pinpad en Electron', sync.error)
  }

  return {
    ok: !!(status?.loggedIn),
    status,
    sync,
  }
}
